var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"help-tag"},[_vm._t("default"),_c('i',{staticClass:"bx bxs-help-circle"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }